import { Component, inject } from '@angular/core';
import { VenueLayoutButtonComponent } from './venue-layout-button/venue-layout-button.component';
import { VenueLayoutContainerComponent } from './venue-layout-container/venue-layout-container.component';
import { VenueLayoutService } from '@services/venue-layout.service';

@Component({
    selector: 'app-venue-layout',
    imports: [
        VenueLayoutButtonComponent,
        VenueLayoutContainerComponent
    ],
    templateUrl: './venue-layout.component.html',
    styleUrl: './venue-layout.component.css'
})
export class VenueLayoutComponent {

  // SERVICES
  protected readonly venueLayout: VenueLayoutService = inject(VenueLayoutService);

}
